import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  investmentStatuses,
  formatCurrency,
  paymentMethods,
  paymentTypes,
} from 'entoro-shared';

const getStatusColor = (value) => {
  if (value === 'IN_PROGRESS') {
    return 'in-progress-status';
  } else if (
    value === 'PENDING_WALLET_ADDRESS' ||
    value === 'PENDING_PAYMENT_VERIFICATION' ||
    value === 'PENDING_TRANSACTION_RECEIPT'
  ) {
    return 'pending-status';
  }

  return 'complete-status';
};

const OfferInvestmentCard = ({
  investment: {
    _id,
    createdAt,
    investmentStatus,
    investmentAmount,
    paymentMethod,
    paymentType,
    paymentSent,
    sharesOrTokensPurchased,
  },
  toggleInvestment,
}) => (
  <div className='docu-card-container'>
    <div className='card-offer'>
      <div className='offer-date'>
        {moment.utc(new Date(createdAt)).format('MM/DD/YYYY')}
      </div>
      <div>({formatCurrency(investmentAmount)})</div>
    </div>
    <div className='card-docu-title w-clearfix'>
      <div className='_13-black-label'>Investment Status</div>
      <div
        className={`text-investment-status ${getStatusColor(investmentStatus)}`}
      >
        {investmentStatuses.getLabel(investmentStatus)}
      </div>
      <div className='_13-black-label'>Payment Method</div>
      <div className='text-payment-details'>
        {paymentMethods.getLabel(paymentMethod)}
      </div>
      <div className='_13-black-label'>Payment Type</div>
      <div className='text-payment-details'>
        {paymentTypes.getLabel(paymentType)}
      </div>
      <div className='_13-black-label'>Payment Sent</div>
      <div className='text-payment-details wallet-address-text'>
        {paymentSent ? 'Yes' : 'No'}
      </div>
      <div className='_13-black-label'>{`${
        paymentMethod === 'CRYPTO' ? 'Tokens' : 'Shares'
      } Purchased`}</div>
      <div className='text-payment-details wallet-address-text'>
        {sharesOrTokensPurchased || 'N/A'}
      </div>
      <button
        onClick={(e) => toggleInvestment(e, _id)}
        className='btn-cancel w-inline-block'
      >
        View Transaction
      </button>
    </div>
  </div>
);

OfferInvestmentCard.propTypes = {
  investment: PropTypes.object.isRequired,
  toggleInvestment: PropTypes.func.isRequired,
};

export default OfferInvestmentCard;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferInvestmentCard.js